import React from 'react';
import useInView from '../hooks/useInView';
import './AnimateOnScroll.css';

/**
 * Componente que anima o conteúdo quando entra na viewport.
 * Variantes: fadeUp, fadeDown, fadeLeft, fadeRight, fadeIn, scaleIn
 */
const AnimateOnScroll = ({ children, variant = 'fadeUp', delay = 0, className = '', as: Tag = 'div', ...props }) => {
  const [ref, isInView] = useInView({ threshold: 0.12 });

  return (
    <Tag
      ref={ref}
      className={`animate-on-scroll animate-on-scroll--${variant} ${isInView ? 'animate-on-scroll--visible' : ''} ${className}`.trim()}
      style={{ transitionDelay: delay ? `${delay}ms` : undefined }}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default AnimateOnScroll;
